<div class="hidden-visually">
    <input type="file" (change)="fileChangeEvent($event)" #uploader accept=".jpg,.jpeg,.png,.gif" />

    <image-cropper
        #cropper
        [imageChangedEvent]="imageChangedEvent"
        format="jpeg"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded($event)"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"
        [maintainAspectRatio]="false"
        [autoCrop]="true"
        [resizeToWidth]="750"
        [onlyScaleDown]="true"
        [output]="output"
        [roundCropper]="roundCropper"
        [imageBase64]="base64Image() || undefined" />
</div>

<div class="image-selector-wrapper" [ngClass]="{ 'justify-center': imageDisplay === 'avatar' }">
    <lib-button
        [disabled]="disabled"
        *ngIf="showAddButton && imageDisplay !== 'avatar'"
        (onClick)="selectFile()"
        class="image-upload-button image-upload-button--{{ imageDisplay }}"
        [ngClass]="{ 'image-upload-button-type--wide': uploadButtonType === 'initial-wide' && !croppedImages.length }"
        [expand]="uploadButtonType === 'initial-wide' && !croppedImages.length"
        [borderStyle]="uploadButtonType === 'initial-wide' && !croppedImages.length ? 'dashed' : 'solid'">
        @if (!disabled) {
            <span
                [ngClass]="{
                    'sr-only':
                        uploadButtonType !== 'initial-wide' ||
                        (uploadButtonType === 'initial-wide' && croppedImages.length)
                }"
                class="flex align-items-center">
                <lib-plus-circle-icon />
                {{ uploadButtonLabel }}
            </span>
            <lib-svg-icon
                [hidden]="uploadButtonType === 'initial-wide' && !croppedImages.length"
                iconName="plus-thin" />
        }
    </lib-button>

    <div *ngIf="imageDisplay === 'avatar'">
        <lib-icon-button
            [disabled]="disabled"
            *ngIf="!croppedImages.length"
            (onClick)="selectFile()"
            display="circle"
            color="var(--ion-color-dark)"
            backgroundColor="var(--ion-color-dark-20)"
            iconName="camera-fill"
            [size]="28"
            [buttonSize]="80"
            [border]="!!errorText"
            [borderColor]="!!errorText ? 'var(--ion-color-danger)' : ''" />

        <lib-avatar-image
            *ngIf="croppedImages.length"
            (onClick)="selectFile()"
            [isClickable]="true"
            [image]="croppedImages[0]"
            [badgeType]="disabled ? undefined : 'edit'"
            [setInitialsAsCurrentUser]="setInitialsAsCurrentUser"
            backgroundColor="var(--ion-color-dark-20)"
            initialsTextColor="#ffffff"
            [borderColor]="!!errorText ? 'var(--ion-color-danger)' : ''" />
    </div>

    <ng-content *ngIf="imageDisplay !== 'avatar'">
        <div *ngFor="let image of croppedImages; index as i" class="image-item  image-item-display--{{ imageDisplay }}">
            <img *ngIf="imageDisplay !== 'none'" [src]="image" class="image-item--image" />
            <lib-icon-button
                class="image-item--remove-icon"
                iconName="trash-outline"
                color="var(--ion-color-danger)"
                backgroundColor="#ffffff"
                [border]="true"
                [buttonSize]="24"
                display="square"
                (onClick)="removeImage(i)"
                [borderColor]="!!errorText ? 'var(--ion-color-danger)' : 'var(--default-light-grey)'" />
        </div>
    </ng-content>
</div>

<div class="invalid-text" *ngIf="errorText" [ngClass]="{ 'text-center': imageDisplay === 'avatar' }">
    <p>{{ errorText }}</p>
</div>
